import {
  parseSingleResponse,
  recursiveDasherizeKeys,
  type BaseResponse,
  type HttpClient,
  type ItemsResponse,
  type SingleResponse,
} from "../../tastyworks"
import {
  QUOTE_ALERT_DESER,
  QuoteAlert,
  type QuoteAlertCreateParams,
} from "../../tastyworks/quote-alert"

const QUOTE_ALERTS_API_VERSION = "20251021"
const QUOTE_ALERTS_API_HEADERS: HeadersInit = {
  "Accept-Version": QUOTE_ALERTS_API_VERSION,
}

const parseQuoteAlert = QUOTE_ALERT_DESER.toParser(QuoteAlert)

export class QuoteAlertService {
  private quoteAlertClient: HttpClient

  constructor(baseHttpClient: HttpClient) {
    this.quoteAlertClient = baseHttpClient.nested("quote-alerts")
  }

  readonly index = async (): Promise<ItemsResponse<QuoteAlert>> =>
    this.quoteAlertClient.indexSimple(
      parseQuoteAlert,
      "",
      undefined,
      QUOTE_ALERTS_API_HEADERS
    )

  readonly create = async ({
    field,
    operator,
    threshold,
    thresholdNumeric,
    symbol,
    dxSymbol,
  }: QuoteAlertCreateParams): Promise<SingleResponse<QuoteAlert>> => {
    const helper = await this.quoteAlertClient.postJson(
      "",
      recursiveDasherizeKeys({
        field,
        operator,
        threshold,
        thresholdNumeric,
        symbol,
        dxSymbol,
      }),
      undefined,
      QUOTE_ALERTS_API_HEADERS
    )

    return parseSingleResponse(helper, parseQuoteAlert)
  }

  readonly dismiss = async (alert: QuoteAlert): Promise<BaseResponse> => {
    if (alert.alertExternalId === null) {
      throw new Error("Quote alert id required")
    }

    return this.quoteAlertClient.destroy(
      ":alertExternalId",
      { alertExternalId: alert.alertExternalId },
      QUOTE_ALERTS_API_HEADERS
    )
  }
}
